
export const ErgonomicsMiniPanel = ({ title, children }) => {
  return (
    <div className="mb-4 rounded-md border-1 border-perception-gray-800">
      <div className='bg-perception-gray-800 flex pl-4 py-[0.15rem]'>
        <span className='text-white text-xs'>{title}</span>
      </div>
      <div className="p-4">
        {children}
      </div>
    </div>
  );
};